document.addEventListener('DOMContentLoaded',function(){  
  
  // HH-b2b-client-about slider 
  var IndexListSlider = new Swiper('.B2BHowTalkClientOutr.swiper',{
    slidesPerView : 1,
    spaceBetween : 52,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 52
      },
      770: {
       slidesPerView: 2,
       spaceBetween: 52
      },
      600: {
       slidesPerView: 2,
       spaceBetween: 52
       },
      479: {
        slidesPerView: 1,
        spaceBetween: 52
      }
    },
  })

  // HH-b2b-userfriendly slider
   var IndexListSlider = new Swiper('.B2BuserFrndFeat_SlideWpr.swiper',{
     slidesPerView : 1,
     spaceBetween : 16,
     loop: true,
     centeredSlides: true,
     pagination: {
        el: ".swiper-pagination",
        clickable: true
     },
     breakpoints: {
      1024: {
        slidesPerView: 1.78999,
        spaceBetween: 16
      },
      770: {
       slidesPerView: 1,
       spaceBetween: 16
      },
      600: {
       slidesPerView: 1,
       spaceBetween: 16
       }
    },
  })

// Brand logo Slider 
  $('.B2B_BrabndLogo_Wpr').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerPadding: '10px',
          centerMode: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '10px',
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '10px',
          slidesToScroll: 1
        }
      }
    ]
  });
  
  if( $(window).width() < 750 ){
    $('.B2B_ProgramSlider_Wpr').not('.slick-initialized').slick({dots: true,arrows: false,  infinite: true,slidesToShow: 1,rows:0});
  }
   window.addEventListener('resize', ()=>{
     if( $(window).width() < 750 ){
         $('.B2B_ProgramSlider_Wpr').not('.slick-initialized').slick({dots: true,arrows: false,  infinite: true,slidesToShow: 1,rows:0}); 
       }else{
          $('.B2B_ProgramSlider_Wpr').slick('destroy'); 
       }
   });

    document.querySelector(".b2bBanner_btn").addEventListener("click", function(event) { event.preventDefault();
      document.querySelector(".B2BHowTalkAbout_clientWrapr").scrollIntoView({ behavior: 'smooth' });
    });
  
});